import { gql } from '@apollo/client';

const ReferralInfoShared = gql`
  fragment ReferralInfoShared on Referral {
    id
    state
    reminders
    consumedAt
    sent
    sentAt
    customerOptions
    source
    hexCode
    isFreeTrial
    orders {
      id
    }
    account {
      id
      accountNumber
      validCreditCard
      onboarded
    }
    partnerOrganizationId
    partnerOrganization {
      id
      name
      address {
        id
        city
        region
        country
      }
    }
    partnerLocationId
    partnerLocation {
      id
      name
      settingGroupOptionIds
      address {
        id
        city
        region
        country
      }
    }
    userId
    userAttributes {
      id
      firstName
      lastName
      state
      email
      phone
    }
    patientAttributes {
      id
      firstName
      lastName
      arches
      dob
      birthDay
      birthMonth
      birthYear
      settingGroupOptionIds
      settingsOverride
      notes
      includeEot
      scanReady
      scanReadyAt
      scanSentAt
      sendToClinic
    }
    createdAt
    updatedAt
  }
`;

export default ReferralInfoShared;
